export default "__VITE_ASSET__e7d3c47e__"